// extracted by mini-css-extract-plugin
export default {"form":"FormSearch_form__mzpwW","formBtn":"FormSearch_formBtn__KtQIF","formInputSearch":"FormSearch_formInputSearch__usyDP","formLabelSearch":"FormSearch_formLabelSearch__y68Bk"};